import React, { FC } from 'react';
import { SectionWrapper } from '../SectionWrapper';
import { useTranslation } from 'react-i18next';
import { FormInput } from '../merchants/FormInput';
import {
  APP_VIEW_CONTACT_INFO_INPUTS,
} from '../../constants/application-view/contact-info-inputs';
import { Title } from '../developers/page-components/Title';
import { CUSTOMER_SUPPORT_INFORMATION_INPUTS } from '../../constants/new-application/customer-support-info';
import { FORM_FIELDS } from '../../constants/new-application/new-application-form';
import { DEVELOPER_INFORMATION_INPUTS } from '../../constants/new-application/developer-information';

interface Props {
  formik: any;
  formEditStatus?: boolean;
    isRequired?: boolean;
}

export const ApplicationViewContactInfo: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { formik, formEditStatus = true, isRequired } = props;

  const link = formik.getFieldProps(FORM_FIELDS.SUPPORT_LINK).value;

  const INPUTS = APP_VIEW_CONTACT_INFO_INPUTS({ t });
  const DEVELOPERS_INPUTS = DEVELOPER_INFORMATION_INPUTS({ t });
  const CUSTOMER_SUPPORT_INPUTS = CUSTOMER_SUPPORT_INFORMATION_INPUTS({ t, link, isRequired });

  return (
      <SectionWrapper
          title={'Contacts'}
          pageLoading={false}
          isCardBody
          sectionAdditionalClass="mb-10"
      >
        <div className="d-flex align-items-center">
          <Title title={t('NEW_APPLICATION.CONTACT_INFORMATION')} additionalClass="fs-4 mb-5" />
        </div>
        <div className="row">
          {
            INPUTS.map(item => (
                <FormInput
                    {...item}
                    formik={formik}
                    key={item.key}
                    isEditMode={formEditStatus}
                />
            ))
          }
        </div>

        <div className="d-flex align-items-center">
          <Title title={t('NEW_APPLICATION.CUSTOMER_SUPPORT_INFORMATION')} additionalClass="fs-4 mb-5" />
        </div>

        <div className="row">
          {
            CUSTOMER_SUPPORT_INPUTS.map(item => {
              return (
                  <FormInput
                      {...item}
                      key={item.key}
                      formik={formik}
                      isEditMode={formEditStatus}
                  />
              );
            })
          }

          <div className="d-flex align-items-center">
            <Title title={t('NEW_APPLICATION.DEVELOPER_INFORMATION')} additionalClass="fs-4 mb-5" />
          </div>

          <div className="row">
            {
              DEVELOPERS_INPUTS.map(item => {
                return (
                    <FormInput
                        {...item}
                        key={item.key}
                        formik={formik}
                        isEditMode={formEditStatus}
                    />
                );
              })
            }
          </div>
        </div>

      </SectionWrapper>
  );
};
